const initialState = {
    partnersList: [],
    totalPartnersCount: 0,
    hierarchyData: []
};

const partnerReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'PARTNERS_LIST': {
            return {
                ...state,
                partnersList: action.payload.partners,
                totalPartnersCount: action.payload.totalCount || 0,
            };
        }
        case 'HIERARCHY_DATA': {
            let hierarchyData = [];
            hierarchyData.push(action.payload)
            return {
                ...state,
                hierarchyData
            };
        }
        case "LOGOUT":
            return initialState;
        default:
            return state;
    }
};

export default partnerReducer;